<script lang="ts">
  import { onMount } from 'svelte'
  import { env } from '$env/dynamic/public'

  const IS_DEVELOPMENT = env.PUBLIC_ENV === 'development'
  const IS_PRODUCTION = !IS_DEVELOPMENT

</script>

<svelte:head>
  <!-- TODO: Remove before merge, this is for debugging -->
  {#if IS_PRODUCTION || true}
  <!-- Google Tag Manager -->
  <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PLVDZJJQ');</script>
  <!-- End Google Tag Manager -->
      <script>
        window.dataLayer = window.dataLayer || []

        function gtag() {
          if (window && 'dataLayer' in window) dataLayer.push(arguments)
        }

        gtag('js', new Date())
      </script>
  {/if}
</svelte:head>

<!-- TODO: Remove before merge, this is for debugging -->
{#if IS_PRODUCTION || true}
  <!-- Google Tag Manager (noscript) -->
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PLVDZJJQ"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  <!-- End Google Tag Manager (noscript) -->
{/if}